import { TooltipProvider } from '@tonic/shared/components/ui'
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { MockDataProvider } from './features/mock-data';
import { App } from './app';

import './index.css';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

// Determine if we should use mock data
const useMockData = import.meta.env.MODE === 'development' || import.meta.env.VITE_USE_MOCK_DATA === 'true';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        {useMockData ? (
          <MockDataProvider>
            <App />
          </MockDataProvider>
        ) : (
          <App />
        )}
      </TooltipProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
